// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const VoiceCommandContextProvider = registerClientReference(
    function() { throw new Error("Attempted to call VoiceCommandContextProvider() from the server but VoiceCommandContextProvider is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/nextapp/src/contexts/VoiceCommandContext.tsx <module evaluation>",
    "VoiceCommandContextProvider",
);
export const useVoiceCommandContext = registerClientReference(
    function() { throw new Error("Attempted to call useVoiceCommandContext() from the server but useVoiceCommandContext is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/nextapp/src/contexts/VoiceCommandContext.tsx <module evaluation>",
    "useVoiceCommandContext",
);
